<template>
  <div>
    <h2>Identité</h2>
    <div
      class="col-100 recherche-avancee-grid recherche-avancee-produits-identite"
    >
      <div class="identite-nom-produit">
        <label for="identite-nom-produit" class="label-bold"
          >Nom du produit</label
        >
        <input
          :value="name"
          @change="$emit('update:name', $event.target.value)"
          type="text"
          id="identite-nom-produit"
        />
      </div>

      <div class="identite-type">
        <label for="identite-type" class="label-bold">Type</label>
        <select
          :value="type"
          @change="$emit('update:type', $event.target.value)"
          id="identite-type"
        >
          <option value=""></option>
          <option v-for="type in this.typesDataset" :key="type">
            {{ type }}
          </option>
        </select>
      </div>

      <div class="identite-statut">
        <label for="identite-statut" class="label-bold"
          >Statut d'autorisation</label
        >
        <select
          :value="status"
          @change="$emit('update:status', $event.target.value)"
          id="identite-statut"
        >
          <option value=""></option>
          <option v-for="status in this.statusDataset" :key="status">
            {{ status }}
          </option>
        </select>
      </div>

      <div class="identite-amm">
        <label for="identite-amm" class="label-bold"
          >N° AMM / PCP / enregistrement Anses</label
        >
        <input
          :value="amm"
          @change="$emit('update:amm', $event.target.value)"
          type="text"
          id="identite-amm"
        />
      </div>

      <div class="identite-categorie">
        <label for="identite-categorie" class="label-bold"
          >Type commercial</label
        >
        <select
          :value="category"
          @change="$emit('update:category', $event.target.value)"
          id="identite-categorie"
        >
          <option
            v-for="category in categoriesDataset"
            :key="category"
            :value="category"
          >
            {{ category }}
          </option>
        </select>
      </div>

      <div class="identite-nature">
        <label for="identite-nature" class="label-bold">Fonction</label>
        <select
          :value="nature"
          @change="$emit('update:nature', $event.target.value)"
          id="identite-nature"
        >
          <option value=""></option>
          <option v-for="nature in this.naturesDataset" :key="nature.name">
            {{ nature.name }}
          </option>
        </select>
      </div>

      <div class="identite-substances">
        <div class="flex flex-row justify-between">
          <label for="identite-substances" class="label-bold"
            >Substance(s) active(s)</label
          >

          <div class="w-3/5">
            <div
              class="relative"
              v-for="(subs, index) in substances"
              :key="index"
            >
              <select
                :value="subs"
                @change="
                  $emit(
                    'update:substances',
                    substances.map((x, ind) =>
                      ind === index ? $event.target.value : x
                    )
                  )
                "
                id="identite-substances"
              >
                <option value=""></option>
                <option
                  v-for="substance in substancesDataset"
                  :key="substance.as_id"
                  :value="substance.as_id"
                >
                  {{ substance.as_name }}
                </option>
              </select>
              <div
                v-if="index === substances.length - 1"
                class="ajout-element"
                @click="$emit('update:substances', substances.concat(['']))"
              ></div>
              <div
                v-else
                class="suppr-element"
                @click="
                  $emit(
                    'update:substances',
                    substances.filter((x, i) => i !== index)
                  )
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="checkboxs checkboxs-product flex flex-row">
          <div class="checkbox">
            <label for="pro">
              <input
                id="pro"
                type="checkbox"
                :value="gamme_pro"
                :checked="gamme_pro === true"
                @change="
                  $emit(
                    'update:gamme_pro',
                    $event.target.checked ? true : false
                  )
                "
              />
              Gamme professionnelle
            </label>
          </div>
          <div class="checkbox">
            <label for="amateur">
              <input
                id="amateur"
                :value="gamme_amateur"
                type="checkbox"
                :checked="gamme_amateur === true"
                @change="
                  $emit(
                    'update:gamme_amateur',
                    $event.target.checked ? true : false
                  )
                "
              />
              Gamme amateur
            </label>
          </div>
        </div>
      </div>

      <div class="identite-firme">
        <label for="identite-firme" class="label-bold">Firme détentrice</label>
        <select
          :value="firm"
          @change="$emit('update:firm', $event.target.value)"
          id="identite-firme"
        >
          <option value=""></option>
          <option v-for="firm in this.firmsDataset" :key="firm">
            {{ firm }}
          </option>
        </select>
      </div>

      <div class="identite-formulation">
        <div>
          <label for="identite-formulation" class="label-bold"
            >Formulation</label
          >
          <div>
            <select
              :value="formulationSigle"
              v-model="formulationSigle"
              @change="$emit('update:formulationSigle', $event.target.value)"
              id="identite-definition"
              style="width: 100%"
            >
              <option value=""></option>
              <option
                v-for="formulationSigle in this.formulationsDataset"
                :key="formulationSigle.code"
                :value="formulationSigle.code"
                id="option-formulation"
                
              >
                {{ formulationSigle.code }} - 
                {{formulationSigle.name}}
              </option>
            </select>
            <!-- <input
              type="text"
              id="identite-definition"
              disabled
              :placeholder="updateLabelFormulation"
              class="pl-2 text-xs"
            /> -->
          </div>
        </div>
        <div class="checkboxs checkboxs-product">
          <div class="checkbox">
            <label>
              <input
                :value="ab"
                :checked="ab === 'true'"
                @change="
                  $emit('update:ab', $event.target.checked ? 'true' : '')
                "
                type="checkbox"
              />
              Utilisable en Agriculture biologique
            </label>
          </div>

          <div class="checkbox">
            <label>
              <input
                :value="biocontrole"
                :checked="biocontrole === 'true'"
                @change="
                  $emit(
                    'update:biocontrole',
                    $event.target.checked ? 'true' : ''
                  )
                "
                type="checkbox"
                id="identite-biocontrole"
              />
              Liste biocontrôle
            </label>
          </div>

          <div class="checkbox">
            <label>
              <input
                :value="bee"
                :checked="bee === 'true'"
                @change="
                  $emit('update:bee', $event.target.checked ? 'true' : '')
                "
                type="checkbox"
                id="identite-mention-abeille"
              />
              Mention Abeille
            </label>
          </div>
          <div class="checkbox">
            <label>
              <input
                :value="cepp"
                :checked="cepp === true"
                @change="
                  $emit('update:cepp', $event.target.checked ? true : false)
                "
                type="checkbox"
                id="identite-mention-abeille"
              />
              Cité dans une fiche CEPP
            </label>
          </div>
        </div>
      </div>

      <div class="identite-famille">
        <label for="identite-famille" class="label-bold">
          Famille chimique de la substance active
        </label>
        <select
          :value="family"
          v-model="family"
          @change="$emit('update:family', $event.target.value)"
          id="identite-famille"
        >
          <option value=""></option>
          <option v-for="family in this.familiesDataset" :key="family">
            {{ family }}
          </option>
        </select>
      </div>

      <div class="identite-date-premiere-autorisation">
        <label for="identite-date-premiere-autorisation" class="label-bold"
          >Date de première autorisation en France</label
        >
        <div class="double-input-row">
          <sign-choice-select
            :value="first_authorisation_dateOperator"
            :required="Boolean(first_authorisation_date)"
            @update="$emit('update:first_authorisation_dateOperator', $event)"
          ></sign-choice-select>
          <input
            type="date"
            :value="first_authorisation_date"
            @change="
              $emit('update:first_authorisation_date', $event.target.value)
            "
            id="identite-date-premiere-autorisation"
          />
        </div>
      </div>

      <div class="identite-date-amm">
        <label for="identite-date-amm" class="label-bold"
          >Date de retrait AMM</label
        >
        <div class="double-input-row">
          <sign-choice-select
            :value="removal_dateOperator"
            :required="Boolean(removal_date)"
            @update="$emit('update:removal_dateOperator', $event)"
          ></sign-choice-select>
          <input
            type="date"
            :value="removal_date"
            @change="$emit('update:removal_date', $event.target.value)"
            id="identite-date-amm"
          />
        </div>
      </div>

      <div class="identite-date-approbation">
        <label for="identite-date-approbation" class="label-bold"
          >Date de fin de commercialisation réglementaire</label
        >
        <div class="double-input-row">
          <sign-choice-select
            :value="end_marketing_dateOperator"
            :required="Boolean(end_marketing_date)"
            @update="$emit('update:end_marketing_dateOperator', $event)"
          ></sign-choice-select>
          <input
            :value="end_marketing_date"
            @change="$emit('update:end_marketing_date', $event.target.value)"
            type="date"
            id="identite-date-approbation"
          />
        </div>
      </div>

      <div class="identite-date-expiration">
        <label for="identite-date-expiration" class="label-bold"
          >Date de fin d'utilisation réglementaire</label
        >
        <div class="double-input-row">
          <sign-choice-select
            :value="end_use_dateOperator"
            :required="Boolean(end_use_date)"
            @update="$emit('update:end_use_dateOperator', $event)"
          ></sign-choice-select>
          <input
            type="date"
            :value="end_use_date"
            @change="$emit('update:end_use_date', $event.target.value)"
            id="identite-date-expiration"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignChoiceSelect from "@/components/SignChoiceSelect";
export default {
  components: { SignChoiceSelect },
  name: "IdentityForm",
  props: {
    // props from searchInput objects
    name: String,
    type: String,
    status: String,
    amm: String,
    category: String,
    nature: String,
    substances: Array,
    firm: String,
    formulationSigle: String,
    formulationDefinition: String,
    ab: String,
    cepp: {required: false},
    gamme_pro: {
      required: false,
    },
    gamme_amateur: {
      required: false,
    },
    
    biocontrole: String,
    bee: String,
    family: String,
    end_marketing_date: String,
    end_marketing_dateOperator: String,
    end_use_date: String,
    end_use_dateOperator: String,
    removal_date: String,
    removal_dateOperator: String,
    first_authorisation_date: String,
    first_authorisation_dateOperator: String,

    // datasets for select input
    typesDataset: Array,
    naturesDataset: Array,
    firmsDataset: Array,
    formulationsDataset: Array,
    familiesDataset: Array,
    substancesDataset: Array,
    statusDataset: Array,
    categoriesDataset: Array,
  },

  methods: {
    updateSubstancesInput(index, value) {
      let result = [...this.substances];
      result[index] = value;
      return result;
    },
    updateLabelFormulation() {
      let label = document.querySelector('#option-formulation')
      console.log(label)
      // return this.formulationSigle.code = this.formulation.name
    }
  },
};
</script>
